(function () {
    new Swiper('.product-photo-exhibition__swiper', {
      loop: true,
      spaceBetween: 0,
      centeredSlides: true,
      //slidesPerView: 3,
      slidesPerView: 'auto',
      breakpoints: {
        // <=
        1400: {
          slidesPerView: 'auto',
        },
        1000: {
          slidesPerView: 'auto',
        },
      },
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.product-photo-exhibition__swiper>.swiper-btn-next',
        prevEl: '.product-photo-exhibition__swiper>.swiper-btn-prev',
      },
    });
  })();